module.exports = __webpack_public_path__ + "img/44-s.3999edd1.png";